import {Component, EventEmitter, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sb-colour-picker',
  templateUrl: './colour-picker.component.html',
  styleUrls: ['./colour-picker.component.scss']
})
export class ColourPickerComponent implements OnInit {

  @Input()
  colour: string = "#909090";

  @Input()
  presetColours = [
    '#6da6e8', '#74c283', '#f9d948', '#f5943f', '#f66c6c', '#ef8ab8', '#696cd4', '#6c6c6c', '#f6f5f5'
  ];

  // Used for binding in knockout context
  @Input()
  onColourChangedCommand: (colour: string) => void;

  colourChanged: EventEmitter<string> = new EventEmitter<string>()

  constructor() { }

  ngOnInit(): void {
  }

  onColourChange(colour: string) {
    this.colourChanged.emit(colour);

    if (this.onColourChangedCommand) {
      this.onColourChangedCommand(colour);
    }
  }

  onChange(event: Event) {
    this.colour = (event.target as HTMLInputElement).value;
    this.onColourChange(this.colour);
  }
}
